import { render, staticRenderFns } from "./transLst.vue?vue&type=template&id=cad253d2&scoped=true&"
import script from "./transLst.vue?vue&type=script&lang=js&"
export * from "./transLst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad253d2",
  null
  
)

export default component.exports